import React, { Component } from "react";
import { ReduxConnect } from "../../../../../toolkit/decorators/Artifact";
import ExternoDetalle from "../../../../../types/ExternoDetalle";
import { MemoTable } from "./TabBitacora.table";
import { Container } from "reactstrap";
import { tabBitacoraStore, TabBitacoraStore } from "./TabBitacora.store";
import {
  tabBitacoraDispatcher,
  TabBitacoraDispatcher
} from "./TabBitacora.dispatcher";

interface Props extends TabBitacoraStore, TabBitacoraDispatcher {
  detalle: ExternoDetalle;
}

interface State {}

@ReduxConnect(tabBitacoraStore, tabBitacoraDispatcher)
export default class TabBitacora extends Component<Props, State> {
  componentDidMount() {
    this.props.getBitacoraInvitado(this.props.detalle.idPersona);
  }

  render() {
    return (
      <Container>
        <MemoTable
          data={this.props.bitacoraInvitado}
          loading={this.props.gettingBitacoraInvitado}
        />
      </Container>
    );
  }
}
